@if (showSpinner) {
<app-loader> </app-loader>
}
@if (isNewsUpdateShow && isNewsUpdateModalShow) {
<app-news-updates [mediaObject]="mediaObject"></app-news-updates>
}
<div class="main-dashboard-wrapper">
  <div class="inner-section-dashboard">
    <div class="inner-common attendance-state-main">
      <div class="card-main">
        <div class="attendace-card-heading">
          <h1>Attendance State</h1>
          <div class="leave-dropdown">
            <select [(ngModel)]="attendanceDuration" (change)="onattendaceDuration($event)">
              <option value="today">Today</option>
              <option value="weekly">This week</option>
              <option value="monthly">This Month</option>
            </select>
          </div>
        </div>
        <div class="attendance-grid-body">
          <div class="card-main attendace-body-card">
            <div class="attend-body-inercard">
              <div class="attend-body-head">
                <div class="attend-body-img all-employee-img">
                  <img src="../../../../assets/theme1/all-emp.png" alt="icon" />
                </div>
                <a [routerLink]="'/attendance-management'" [state]="{ type: 'pounch-in'}">
                  @if ((!showSpinner) && punchindata) {
                  <h1>
                    {{ punchindata.total_user }} Employees
                  </h1>
                  } @else {
                  <div class="punchinskeleton skeleton-text"></div>
                  }
                </a>
              </div>
              <h2>Total Punch In</h2>
            </div>
            <div class="attend-footer-inercard">
              <div class="attend-part">
                <div class="attend-footer-list">
                  @if (punchindata) {
                  <ul>
                    <li>
                      <div class="dot-color machine">
                      </div>
                      <p>From Machine</p>
                      <p>{{ punchindata.total_attendance_machine}}</p>
                    </li>
                    <li>
                      <div class="dot-color portal">
                      </div>
                      <p>From Portal</p>
                      <p>{{punchindata.total_web_portal}}</p>
                    </li>
                    <li>
                      <div class="dot-color mobile">
                      </div>
                      <p>From Mobile</p>
                      <p>{{punchindata.total_mobile_portal}}</p>
                    </li>
                  </ul>
                  }
                </div>
              </div>
              <div class="attend-part donut-chart-sec">
                @if (chartOptions) {
                <apx-chart [series]="chartData" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
                  [colors]="chartOptions.colors" [plotOptions]="chartOptions.plotOptions" [legend]="chartOptions.legend"
                  [dataLabels]="chartOptions.dataLabels" [stroke]="chartOptions.stroke">
                </apx-chart>
                }
                @if (getLargestSource() === 'mobile') {
                <div class="chart-heading">
                  <h1>Peak</h1>
                  <p>Mobile</p>
                </div>
                }
                @if (getLargestSource() === 'portal') {
                <div class="chart-heading">
                  <h1>Peak</h1>
                  <p>Portal</p>
                </div>
                }
                @if (getLargestSource() === 'machine') {
                <div class="chart-heading">
                  <h1>Peak</h1>
                  <p>Machine</p>
                </div>
                }
                @if (getLargestSource() === 'no_data') {
                <div class="chart-heading">
                  <h1>No</h1>
                  <p>Data</p>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="card-main attendace-body-card">
            <div class="attend-body-inercard">
              <div class="attend-body-head">
                <div class="attend-body-img out-employee-img">
                  <img src="../../../../assets/theme1/punch-out.png" alt="icon" />
                </div>
                <a [routerLink]="'/attendance-management'" [state]="{ type: 'pounch-out'}">
                  @if ((!showSpinner) && punchoutdata) {
                  <h1>
                    {{ punchoutdata.total_user }} Employees
                  </h1>
                  } @else {
                  <div class="punchoutskeleton skeleton-text"></div>
                  }
                </a>
              </div>
              <h2>Total Punch out</h2>
            </div>
            <div class="attend-footer-inercard">
              <div class="attend-part">
                <div class="attend-footer-list">
                  @if (punchoutdata) {
                  <ul>
                    <li>
                      <div class="dot-color out-machine">
                      </div>
                      <p>From Machine</p>
                      <p>{{punchoutdata.total_from_portal}}</p>
                    </li>
                    <li>
                      <div class="dot-color out-portal">
                      </div>
                      <p>From Portal</p>
                      <p>{{punchoutdata.total_web_portal}}</p>
                    </li>
                    <li>
                      <div class="dot-color out-mobile">
                      </div>
                      <p>From Mobile</p>
                      <p>{{ punchoutdata.total_mobile_portal}}</p>
                    </li>
                  </ul>
                  }
                </div>
              </div>
              <div class="attend-part donut-chart-sec">
                @if (newChartOptions) {
                <apx-chart [series]="newChartData" [chart]="newChartOptions.chart" [labels]="newChartOptions.labels"
                  [colors]="newChartOptions.colors" [plotOptions]="newChartOptions.plotOptions"
                  [legend]="newChartOptions.legend" [dataLabels]="newChartOptions.dataLabels"
                  [stroke]="newChartOptions.stroke">
                </apx-chart>
                }
                @if (getLargestoutSource() === 'mobile') {
                <div class="chart-heading">
                  <h1>Peak</h1>
                  <p>Mobile</p>
                </div>
                }
                @if (getLargestoutSource() === 'portal') {
                <div class="chart-heading">
                  <h1>Peak</h1>
                  <p>Portal</p>
                </div>
                }
                @if (getLargestoutSource() === 'machine') {
                <div class="chart-heading">
                  <h1>Peak</h1>
                  <p>Machine</p>
                </div>
                }
                @if (getLargestoutSource() === 'no_data') {
                <div class="chart-heading">
                  <h1>No</h1>
                  <p>Data</p>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="common-detail-card">
            <div class="card-main absent-card">
              <div class="comon-detail-inercard">
                <div class="attend-body-head">
                  <div class="attend-body-img out-employee-img">
                    <img src="../../../../assets/theme1/absent.png" alt="icon" />
                  </div>
                  <div class="anchor" (click)="settodayattendance()">
                    @if (!showSpinner) {
                    <h1 class="total-absent">
                      {{ total_absent }} Employees
                    </h1>
                    } @else {
                    <div class="demoskeleton total-absent-skeleton"></div>
                    }
                  </div>
                </div>
                <h2>Absents</h2>
              </div>
            </div>
            <div class="card-main late-card">
              <div class="comon-detail-inercard">
                <div class="attend-body-head">
                  <div class="attend-body-img out-employee-img">
                    <img src="../../../../assets/theme1/punch-out.png" alt="icon" />
                  </div>
                  <a [routerLink]="'/attendance-management'" [state]="{ type: 'late-punchin'}">
                    @if (!showSpinner) {
                    <h1 class="late-check-in">
                      {{ late_check_in }} Employees
                    </h1>
                    } @else {
                    <div class="demoskeleton late-check-in-skeleton"></div>
                    }
                  </a>
                </div>
                <h2>Late Punch In</h2>
              </div>
            </div>
          </div>
          <div class="common-detail-card">
            <div class="card-main short-card">
              <div class="comon-detail-inercard">
                <div class="attend-body-head">
                  <div class="attend-body-img short-employee-img">
                    <img src="../../../../assets/theme1/clock-fast-forward.png" alt="icon" />
                  </div>
                  <a [routerLink]="'/attendance-management'" [state]="{ type: 'short-time'}">
                    @if (!showSpinner) {
                    <h1 class="total-shorttime">
                      {{ total_shorttime }} Employees
                    </h1>
                    } @else {
                    <div class="demoskeleton total-shorttime-skeleton"></div>
                    }
                  </a>
                </div>
                <h2>Short Time</h2>
              </div>
            </div>
            <div class="card-main overtime-card">
              <div class="comon-detail-inercard">
                <div class="attend-body-head">
                  <div class="attend-body-img over-employee-img">
                    <img src="../../../../assets/theme1/overtime.png" alt="icon" />
                  </div>
                  <a [routerLink]="'/attendance-management'" [state]="{ type: 'overtime'}">
                    @if (!showSpinner) {
                    <h1 class="overtime">
                      {{ overtime }} Employees
                    </h1>
                    } @else {
                    <div class="demoskeleton overtime-skeleton"></div>
                    }
                  </a>

                </div>
                <h2>Over Time</h2>
              </div>
            </div>
          </div>
          <div class="common-detail-card">
            <div class="card-main missing-card">
              <div class="comon-detail-inercard">
                <div class="attend-body-head">
                  <div class="attend-body-img check-missing-employee-img">
                    <img src="../../../../assets/theme1/missing.png" alt="icon" />
                  </div>
                  <a [routerLink]="'/attendance-management'" [state]="{ type: 'miss-checkout'}">
                    @if (!showSpinner) {
                    <h1 class="miss-checkout">
                      {{ miss_checkOut }} Employees
                    </h1>
                    } @else {
                    <div class="demoskeleton miss-checkout-skeleton"></div>
                    }
                  </a>
                </div>
                <h2>Punch Out Missing</h2>
              </div>
            </div>
            <div class="card-main good-card">
              <div class="comon-detail-inercard">
                <div class="attend-body-head">
                  <div class="attend-body-img good-employee-img">
                    <img src="../../../../assets/theme1/good.png" alt="icon" />
                  </div>
                  <a [routerLink]="'/attendance-management'" [state]="{ type: 'good-work'}">
                    @if (!showSpinner) {
                    <h1 class="good-work">
                      {{ goodWork }} Employees
                    </h1>
                    } @else {
                    <div class="demoskeleton good-work-skeleton"></div>
                    }
                  </a>

                </div>
                <h2>Good Workers</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="admin-dash-body mt-3">
      <div class="main-body-left-side">
        <div class="main-body-head">
          <div class="head-comon head-evaluation">
            <div class="card-main pb-0">
              <div class="comon-head leave-section">
                <h1>Top 3 Evaluations</h1>
                <div class="gallery-rout" [routerLink]="['/evaluation-list']">
                  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 6H13M13 6L8.5 1.5M13 6L8.5 10.5" stroke="#2D2D2E" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              @if (hasEvaluationData) {
              <div>
                @if (linechartOptions) {
                <apx-chart [series]="linechartOptions.series" [chart]="linechartOptions.chart"
                  [xaxis]="linechartOptions.xaxis" [yaxis]="linechartOptions.yaxis"
                  [dataLabels]="linechartOptions.dataLabels" [stroke]="linechartOptions.stroke"
                  [fill]="linechartOptions.fill" [tooltip]="linechartOptions.tooltip"
                  [markers]="linechartOptions.markers">
                </apx-chart>
                }
              </div>
              } @else {
              <div class="no-data evalutaion-nodata-img">
                <img src="../../../assets/theme1/nodata.png" alt="No data available">
                <!-- <p>No evaluation data available</p> -->
              </div>
              }

            </div>
          </div>
          <div class="head-comon total-leaves-head">
            <div class="card-main pb-0">
              <div class="comon-head leave-section">
                <h1>Total Leaves</h1>
                <div class="leave-dropdown">
                  <select [(ngModel)]="selectedDuration" (change)="onDurationChange($event)">
                    <option value="today">Today</option>
                    <option value="weekly">This week</option>
                    <option value="monthly">This Month</option>
                  </select>
                </div>
              </div>
              <div class="leave-section-body">
                <div class="leave-content">
                  <div class="leave-content-list">
                    <ul>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce total-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Total Leaves</p>
                          <h1>{{leaveslogs.total_leaves}}</h1>
                        </div>
                      </li>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce paid-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Paid Leaves</p>
                          <h1>{{leaveslogs.paid_leaves}}</h1>
                        </div>
                      </li>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce unpaid-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Unpaid Leaves</p>
                          <h1>{{leaveslogs.unpaid_leaves}}</h1>
                        </div>
                      </li>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce absent-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Absents</p>
                          <h1>{{leaveslogs.absents}}</h1>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="leave-bubbles">
                  <div class="leavedata-circle unpaid-cirle-main">
                    <p>Unpaid</p>
                    <p>{{leaveslogs.unpaid_leaves }}</p>
                  </div>
                  <div class="leavedata-circle paid-cirle-main">
                    <p>Total</p>
                    <p>{{leaveslogs.total_leaves}}</p>
                  </div>
                  <div class="leavedata-circle absent-cirle-main">
                    <p>Paid </p>
                    <p>{{leaveslogs.paid_leaves}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="main-body-footer mt-3">
          <div class="aniversary shift-anivar">
            <div class="card-main year-section">
              <div class="card-heading">
                <h1>Years of Work</h1>
              </div>
              <div class="year-work-body">
                <h1>{{ anniversary_count }} Aniversary</h1>
                <div class="prgress-chart">
                  <div id="progress2">
                    @if (optionsProgress3) {

                    <apx-chart [series]="optionsProgress3.series" [chart]="optionsProgress3.chart"
                      [plotOptions]="optionsProgress3.plotOptions" [colors]="optionsProgress3.colors"
                      [stroke]="optionsProgress3.stroke" [fill]="optionsProgress3.fill" [title]="optionsProgress3.title"
                      [subtitle]="optionsProgress3.subtitle" [tooltip]="optionsProgress3.tooltip"
                      [xaxis]="optionsProgress3.xaxis" [yaxis]="optionsProgress3.yaxis">
                    </apx-chart>
                    }
                  </div>
                </div>
              </div>
              <div class="year-work-timer">
                <h1>{{aniversarydays}}<span>Days</span></h1>
                <h1>:</h1>
                <h1>{{aniversaryhours}} <span>Hours</span></h1>
                <h1>:</h1>
                <h1>{{aniversaryminutes}} <span>Minutes</span></h1>
                <h1>:</h1>
                <h1>{{aniversaryseconds}} <span>Seconds</span></h1>
              </div>
            </div>
          </div>
          <div class="head-count">
            <div class="card-main">
              <div class="card-heading">
                <h1>Head Count</h1>
              </div>
              <div class="total-user-main-sec">
                <div class="total-user-detail">
                  <div class="shift-detail-section">
                    <div class="shift-detail-main">
                      <div class="shift-time">
                        <div class="border-section">
                          <div class="circle bule-circle">

                          </div>
                        </div>
                        <div class="shit-content-sec">
                          <h2>Total Members</h2>
                          <h1>
                            {{countlogs.total_user_count}}
                          </h1>
                        </div>
                      </div>

                      <div class="shift-time">
                        <div class="border-section">
                          <div class="circle pink-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec">
                          <h2>{{subdepartment_count[0].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[0].user_count}}</span>
                          </h1>
                        </div>
                        }
                      </div>
                      <div class="shift-time">
                        <div class="border-section last-border-section">
                          <div class="circle yellow-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec">
                          <h2>{{subdepartment_count[1].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[1].user_count}}</span>
                          </h1>
                        </div>
                        }
                      </div>
                    </div>
                    <div class="shift-detail-main">
                      <div class="shift-time">
                        <div class="border-section">
                          <div class="circle bule-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec">
                          <h2>{{subdepartment_count[2].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[2].user_count}}</span>
                          </h1>
                        </div>
                        }
                      </div>

                      <div class="shift-time">
                        <div class="border-section">
                          <div class="circle pink-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec">
                          <h2>{{subdepartment_count[3].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[3].user_count}}</span>
                          </h1>
                        </div>
                        }
                      </div>
                      <div class="shift-time">
                        <div class="border-section last-border-section">
                          <div class="circle yellow-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec">
                          <h2>{{subdepartment_count[4].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[4].user_count}}</span>
                          </h1>
                        </div>
                        }
                      </div>
                    </div>
                    <div class="shift-detail-main">
                      <div class="shift-time">
                        <div class="border-section hiden-border">
                          <div class="circle bule-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec hiden-shift-time">
                          <h2>{{subdepartment_count[5].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[5].user_count}}</span>
                          </h1>
                        </div>
                        }
                        <div class="shit-content-sec big-hiden">
                          <h2 type="button" data-toggle="tooltip" data-placement="top" [attr.title]="getTooltipText()">
                            others
                          </h2>
                        </div>
                      </div>

                      <div class="shift-time hiden-shift-time">
                        <div class="border-section last-border-section">
                          <div class="circle yellow-circle">

                          </div>
                        </div>
                        @if (subdepartment_count && subdepartment_count.length > 0) {
                        <div class="shit-content-sec">
                          <h2>{{subdepartment_count[6].department}}</h2>
                          <h1>
                            <span>{{subdepartment_count[6].user_count}}</span>
                          </h1>
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="total-user-graph">
                  <div class="attend-part donut-chart-sec">
                    @if (donutChartOptions && donutChartData.length) {
                    <apx-chart [series]="donutChartData" [chart]="donutChartOptions.chart"
                      [labels]="donutChartOptions.labels" [colors]="donutChartOptions.colors"
                      [plotOptions]="donutChartOptions.plotOptions" [legend]="donutChartOptions.legend"
                      [dataLabels]="donutChartOptions.dataLabels" [stroke]="donutChartOptions.stroke">
                    </apx-chart>
                    }
                    <div class="chart-heading total-member-chart">
                      <h1> {{countlogs.total_user_count}}</h1>
                      <p>Members</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="head-comon total-leaves-head-down">
            <div class="card-main pb-0">
              <div class="comon-head leave-section">
                <h1>Total Leaves</h1>
                <div class="leave-dropdown">
                  <select [(ngModel)]="selectedDuration" (change)="onDurationChange($event)">
                    <option value="today">Today</option>
                    <option value="weekly">This week</option>
                    <option value="monthly">This Month</option>
                  </select>
                </div>
              </div>
              <div class="leave-section-body">
                <div class="leave-content">
                  <div class="leave-content-list">
                    <ul>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce total-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Total Leaves</p>
                          <h1>{{leaveslogs.total_leaves}}</h1>
                        </div>
                      </li>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce paid-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Paid Leaves</p>
                          <h1>{{leaveslogs.paid_leaves}}</h1>
                        </div>
                      </li>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce unpaid-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Unpaid Leaves</p>
                          <h1>{{leaveslogs.unpaid_leaves}}</h1>
                        </div>
                      </li>
                      <li>
                        <div class="content-list-left">
                          <div class="leave-cirlce absent-leave-circle">
                          </div>
                        </div>
                        <div class="content-list-right">
                          <p>Absents</p>
                          <h1>{{leaveslogs.absents}}</h1>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="leave-bubbles">
                  <div class="leavedata-circle unpaid-cirle-main">
                    <p>Unpaid</p>
                    <p>{{leaveslogs.unpaid_leaves }}</p>
                  </div>
                  <div class="leavedata-circle paid-cirle-main">
                    <p>Total</p>
                    <p>{{leaveslogs.total_leaves}}</p>
                  </div>
                  <div class="leavedata-circle absent-cirle-main">
                    <p>Paid </p>
                    <p>{{leaveslogs.paid_leaves}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-body-right-side">
        <div class="card-main">
          <div class="card-heading mb-0">
            <h1>Requests</h1>
            <div class="request-tabs">
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button class="nav-link" [ngClass]="{'active': selectedTab === 'leave'}"
                    (click)="onTabSelect('leave')" id="nav-leave-tab" data-bs-toggle="tab" data-bs-target="#nav-leave"
                    type="button" role="tab" aria-controls="nav-leave" aria-selected="true">
                    Leave
                  </button>

                  <button class="nav-link" [ngClass]="{'active': selectedTab === 'attendance'}"
                    (click)="onTabSelect('attendance')" id="nav-attendance-tab" data-bs-toggle="tab"
                    data-bs-target="#nav-attendance" type="button" role="tab" aria-controls="nav-attendance"
                    aria-selected="false">
                    Attendance
                  </button>

                  <button class="nav-link" [ngClass]="{'active': selectedTab === 'loan'}" (click)="onTabSelect('loan')"
                    id="nav-loan-tab" data-bs-toggle="tab" data-bs-target="#nav-loan" type="button" role="tab"
                    aria-controls="nav-loan" aria-selected="false">
                    Loan
                  </button>
                </div>
              </nav>
            </div>
          </div>
          <div class="reques-body">
            <div class="tab-content">
              <div class="tab-content border bg-light" id="nav-tabContent">

                <!-- leave tab -->

                <div class="tab-pane fade active show" id="nav-leave" role="tabpanel" aria-labelledby="nav-leave-tab">
                  @if ((leaveRequests && leaveRequests.length > 0) && isavailablefeatureforLeave('isView')) {
                  <div class="tab-pane-heading">
                    <h1>Total Leave Requests</h1>
                    <strong>{{ notify1.count }}</strong>
                  </div>
                  @for (data of datarequest; track data) {
                  <div class="tab-pane-body">
                    <div class="tab-pane-section">
                      <div class="tab-pane-section-head tab-leave-head">
                        <div class="pane-circle">
                        </div>
                        <p>{{data.leave_payment_status | titlecase}} Leave</p>
                      </div>
                      <div class="tab-pane-section-body unpaid-pane-section">
                        <div class="pane-user-image">
                          <img
                            [src]="data?.user?.profile_image ? data?.user?.profile_image : '../../assets/images/question.jpg'"
                            alt="">
                        </div>
                        <div class="pane-user-detail">
                          <div class="pane-user-detail-head">
                            <p>{{data.user.sub_department}}</p>
                            <p>
                              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3273_18449)">
                                  <path
                                    d="M7.00008 4.00002V7.50002L9.33341 8.66669M12.8334 7.50002C12.8334 10.7217 10.2217 13.3334 7.00008 13.3334C3.77842 13.3334 1.16675 10.7217 1.16675 7.50002C1.16675 4.27836 3.77842 1.66669 7.00008 1.66669C10.2217 1.66669 12.8334 4.27836 12.8334 7.50002Z"
                                    stroke="#555555" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3273_18449">
                                    <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              {{data.created_time}}
                            </p>
                          </div>
                          <div class="pane-user-detail-body">
                            <p>
                              <strong>{{data.user.first_name}} {{data.user.last_name}}</strong>
                              requested {{ calculateDaysAndFormatRange(data.start_date, data.end_date).totalDays
                              }}
                              {{data.leave_name}} {{data.leave_payment_status}} Leaves from {{
                              calculateDaysAndFormatRange(data.start_date, data.end_date).dateRange }}.
                            </p>
                          </div>
                          @if (isavailablefeatureforLeave('isAccept')) {
                          <div class="pane-user-detail-footer">
                            <div class="accept-button" data-bs-toggle="modal" data-bs-target="#acceptleaveModalCenter">
                              Accept</div>
                            @if (isavailablefeatureforLeave('isReject')) {
                            <div class="reject-button" data-bs-toggle="modal" data-bs-target="#rejectleaveModalCenter"
                              (click)="openRejectModal(data.id)">Reject</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="modal fade" id="acceptleaveModalCenter" tabindex="-1" role="dialog"
                      aria-labelledby="acceptleaveModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="acceptleaveModalLongTitle">Accept Leave</h5>
                            <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body leave-delete-body">
                            <div class="header-icon">
                              <i class="fa fa-question-circle"></i>
                            </div>
                            <p>Are you sure you want to Accept this leave?</p>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-danger" id="closeButton"
                                (click)="closeModal()">No</button>
                              <button type="submit" class="btn btn-success" (click)="approveleave(data)">Accept</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal fade" id="rejectleaveModalCenter" tabindex="-1" role="dialog"
                      aria-labelledby="rejectleaveModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="rejectleaveModalLongTitle">Reject Leave</h5>
                            <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body leave-delete-body">
                            <div class="header-icon">
                              <i class="fa fa-question-circle"></i>
                            </div>
                            Are you sure you want to Reject this leave?
                            <form #reason="ngForm" (ngSubmit)="reject(reason)">
                              <div class="modal-body d-flex flex-wrap justify-content-center">
                                <div class="col-12 mt-2 mb-2 text-box">
                                  <textarea class="form-control" id="rejected_reason" type="text" inputmode="none"
                                    rows="3" name="rejected_reason" placeholder="Enter Reason "
                                    [(ngModel)]="rejectedReason" #r="ngModel" required></textarea>
                                  @if (r.valid && r.touched) {
                                  <div>
                                    @if (reason.value.rejected_reason.length < 50 ) { <p
                                      class="alert alert-warning mt-2">
                                      Ensure that the entered <strong>Reason</strong> contains minimum of 50
                                      characters.
                                      </p>
                                      }
                                  </div>
                                  }
                                  <!-- automated text here -->
                                  @if (leaveRejectionData && leaveRejectionData.length > 0) {
                                  <div class="mt-4">
                                    <!-- <p>Automated Text</p> -->
                                    @for (item of leaveRejectionData; track item) {
                                    <div>
                                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}
                                      </p>
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-danger" id="closeButton"
                                  (click)="closeModal()">Close</button>
                                @if (reason.value.rejected_reason; as rejected) {
                                <button type="submit" class="btn btn-success"
                                  [disabled]="reason.invalid || rejected.length < 50">Confirm
                                  Reject</button>
                                }
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <!-- ✅ View More only when there is data -->
                  <div class="view-more-button">
                    <a [routerLink]="['/show-leaves']">
                      View More
                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6H13M13 6L8.5 1.5M13 6L8.5 10.5" stroke="#2D2D2E" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  } @else {
                  <div class="no-data">
                    <ng-lottie width="100%" height="auto" [options]="options"></ng-lottie>
                  </div>
                  }

                </div>



                <!-- atttendance tab -->

                <div class="tab-pane fade" id="nav-attendance" role="tabpanel" aria-labelledby="nav-attendance-tab">

                  @if ((attendanceRequests && attendanceRequests.length > 0) && isavailablefeature('isView')) {
                  <div class="tab-pane-heading">
                    <h1>Total Attendance Requests</h1>
                    <strong>{{Attendanceotificaton.total_count}}</strong>
                  </div>
                  @for (data of datarequest; track data) {
                  <div class="tab-pane-body">
                    <div class="tab-pane-section">
                      <div class="tab-pane-section-head tab-paidleave-head">
                        <div class="pane-circle">
                        </div>
                        <p>{{data.type | titlecase}} Correction</p>
                      </div>
                      <div class="tab-pane-section-body unpaid-pane-section">
                        <div class="pane-user-image">
                          <img
                            [src]="data?.user?.profile_image ? data?.user?.profile_image : '../../assets/images/question.jpg'"
                            alt="">
                        </div>
                        <div class="pane-user-detail">
                          <div class="pane-user-detail-head">
                            <p>{{data.user.sub_department}}</p>
                            <p>
                              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3273_18449)">
                                  <path
                                    d="M7.00008 4.00002V7.50002L9.33341 8.66669M12.8334 7.50002C12.8334 10.7217 10.2217 13.3334 7.00008 13.3334C3.77842 13.3334 1.16675 10.7217 1.16675 7.50002C1.16675 4.27836 3.77842 1.66669 7.00008 1.66669C10.2217 1.66669 12.8334 4.27836 12.8334 7.50002Z"
                                    stroke="#555555" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3273_18449">
                                    <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              {{data.created_time}}
                            </p>
                          </div>
                          <div class="pane-user-detail-body">
                            <p>
                              <strong>{{data.user.first_name}} {{data.user.last_name}}</strong>
                              reports he {{data.type}} at {{data.check_in}} {{
                              calculateDaysAndFormatRange(data.date, data.date).dateRange }}.
                            </p>
                          </div>
                          @if (isavailablefeature('isAccept') || isavailablefeature('isReject')) {
                          <div class="pane-user-detail-footer">
                            @if (isavailablefeature('isAccept')) {
                            <div class="accept-button" data-toggle="modal" data-target="#updateModal"
                              (click)="sendAcceptedData(data)">Accept</div>
                            }
                            @if (isavailablefeature('isReject')) {
                            <div class="reject-button" data-toggle="modal" data-target="#rejectupdateModal"
                              (click)="sendRejectedData(data)">Reject</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="updateModal" tabindex="-1" role="dialog"
                      aria-labelledby="updateModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-dialog-xl" role="document">
                        <div class="modal-content">
                          <form #attendance="ngForm" (ngSubmit)="aproveReq(attendance)">
                            <div class="modal-header">
                              <h5 class="modal-title" id="updateModalLongTitle">
                                Attendance Request Accept
                              </h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <!-- <div class="modal-header">
                                            <h5 class="modal-title" id="updateModalLongTitle">
                                              Reason
                                            </h5>
                                          </div> -->
                            <div class="modal-body">
                              <div class="attendance-body-head">
                                <img src="../../assets/images/authentication.png" alt="Missing image" />
                              </div>
                              <div class="input-field-main">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <textarea class="form-control pl-4" id="" rows="3" name="reason" ngModel
                                      #updateReason="ngModel" placeholder="Enter Reason*" required
                                      [(ngModel)]="reasonModal"></textarea>
                                    @if (updateReason.valid && (updateReason.dirty || updateReason.touched)) {
                                    <div>
                                      @if (reasonModal !== undefined && reasonModal.trim().length < 50 ) { <p
                                        class="alert alert-warning mt-2">Ensure that the entered
                                        <strong>Reason</strong> contains a minimum of 50 characters.
                                        </p>
                                        }
                                    </div>
                                    }
                                  </div>
                                  <!-- automated text here -->
                                  @if (acceptanceData && acceptanceData.length > 0) {
                                  <div>
                                    <!-- <p>Automated Text</p> -->
                                    @for (item of acceptanceData; track item) {
                                    <div>
                                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}
                                      </p>
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                Close
                              </button>
                              <button type="submit" class="btn btn-primary" [disabled]="
                                attendance.invalid || (reason !== undefined && reason.trim().length < 50)
                              ">
                                Approve
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div class="modal fade" id="rejectupdateModal" tabindex="-1" role="dialog"
                      aria-labelledby="rejectupdateModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-dialog-xl" role="document">
                        <div class="modal-content">
                          <form #attendance="ngForm" (ngSubmit)="rejectReq(attendance)">
                            <div class="modal-header">
                              <h5 class="modal-title" id="updateModalLongTitle">
                                Attendance Request Reject
                              </h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="attendance-body-head">
                                <img src="../../assets/images/authentication.png" alt="Missing image" />
                              </div>
                              <div class="input-field-main">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <textarea class="form-control modal-text-area pl-4" id="" rows="3" name="reason1"
                                      ngModel #updateReason="ngModel" placeholder="Enter Reason*" required
                                      [(ngModel)]="reason1"></textarea>
                                    @if (
                                    updateReason.valid &&
                                    (updateReason.dirty || updateReason.touched)
                                    ) {
                                    <div>
                                      @if (reason1 !== undefined && reason1.trim().length < 50) { <p
                                        class="alert alert-warning mt-2">
                                        Ensure that the entered <strong>Reason</strong> contains
                                        a minimum of 50 characters.
                                        </p>
                                        }
                                    </div>
                                    }
                                  </div>
                                  @if (RejectionData && RejectionData.length > 0) {
                                  <div>
                                    <!-- <p>Automated Text</p> -->
                                    @for (item of RejectionData; track item) {
                                    <div>
                                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}
                                      </p>
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                Close
                              </button>
                              <button type="submit" class="btn btn-primary"
                                [disabled]="!reason1.trim() || reason1.trim().length < 50">Rejected</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <!-- ✅ View More only when there is data -->
                  <div class="view-more-button">
                    <a [routerLink]="['/attendance-management']">
                      View More
                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6H13M13 6L8.5 1.5M13 6L8.5 10.5" stroke="#2D2D2E" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  } @else {
                  <div class="no-data">
                    <ng-lottie width="100%" height="auto" [options]="options"></ng-lottie>
                  </div>
                  }

                </div>





                <!-- loan tab -->
                <div class="tab-pane fade" id="nav-loan" role="tabpanel" aria-labelledby="nav-loan-tab">

                  @if ((loanRequests && loanRequests.length > 0) && isLoanApprovedPermission('isloanView')) {
                  <div class="tab-pane-heading">
                    <h1>Total Loan Requests</h1>
                    <strong>{{ loannotification.total_count }}</strong>
                  </div>
                  @for (data of datarequest; track data) {
                  <div class="tab-pane-body">
                    <div class="tab-pane-section">
                      <div class="tab-pane-section-head tab-leave-head">
                        <div class="pane-circle">
                        </div>
                        <p>Loan Request</p>
                      </div>
                      <div class="tab-pane-section-body unpaid-pane-section">
                        <div class="pane-user-image">
                          <img
                            [src]="data?.user?.profile_image ? data?.user?.profile_image : '../../assets/images/question.jpg'"
                            alt="">
                        </div>
                        <div class="pane-user-detail">
                          <div class="pane-user-detail-head">
                            <p>{{data.user.sub_department}}</p>
                            <p>
                              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3273_18449)">
                                  <path
                                    d="M7.00008 4.00002V7.50002L9.33341 8.66669M12.8334 7.50002C12.8334 10.7217 10.2217 13.3334 7.00008 13.3334C3.77842 13.3334 1.16675 10.7217 1.16675 7.50002C1.16675 4.27836 3.77842 1.66669 7.00008 1.66669C10.2217 1.66669 12.8334 4.27836 12.8334 7.50002Z"
                                    stroke="#555555" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3273_18449">
                                    <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              {{data.created_time}}
                            </p>
                          </div>
                          <div class="pane-user-detail-body">
                            <p>
                              <strong>{{data.user.first_name}} {{data.user.last_name}}</strong>
                              requested loan of {{data.loan_amount}} on {{
                              calculateDaysAndFormatRange(data.loan_date, data.loan_date).dateRange }}
                              the Loan duration is {{data.loan_duration}} months with installments of
                              {{data.installment}}.
                            </p>
                          </div>
                          @if (isLoanApprovedPermission('isAccept') || isLoanApprovedPermission('isReject')) {
                          <div class="pane-user-detail-footer">
                            @if (isLoanApprovedPermission('isAccept')) {
                            <div class="accept-button" (click)="setloanData(data)" data-toggle="modal"
                              data-target="#acceptloanModal">Accept
                            </div>
                            }
                            @if (isLoanApprovedPermission('isReject')) {
                            <div class="reject-button" (click)="setloanData(data)" data-toggle="modal"
                              data-target="#rejectloanModal">Reject
                            </div>
                            }
                          </div>
                          }
                          <div class="modal fade" id="acceptloanModal" tabindex="-1" role="dialog"
                            aria-labelledby="updateModalCenterTitle" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-xl" role="document">
                              <div class="modal-content">
                                <form #loan="ngForm" (ngSubmit)="aproveLoan(loan)">
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="updateModalLongTitle">
                                      Loan Request
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <div class="attendance-body-head loan-head">
                                      <img src="../../../../assets/theme1/loan-req.png" alt="Missing image" />
                                    </div>
                                    <div class="input-field-main">
                                      <div class="col-md-12">
                                        <p class="warning-title">Are you Sure You Want To Accept This Request?</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                      No
                                    </button>
                                    <button type="submit" class="btn btn-primary">
                                      Yes
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div class="modal fade" id="rejectloanModal" tabindex="-1" role="dialog"
                            aria-labelledby="updateModalCenterTitle" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-xl" role="document">
                              <div class="modal-content">
                                <form #loan="ngForm" (ngSubmit)="rejetcLoan(loan)">
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="updateModalLongTitle">
                                      Loan Request
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <div class="attendance-body-head loan-head">
                                      <img src="../../../../assets/theme1/loan-req.png" alt="Missing image" />
                                    </div>
                                    <div class="input-field-main">
                                      <div class="col-md-12">
                                        <p class="warning-title">Are you Sure You Want To Reject This Request?</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                      No
                                    </button>
                                    <button type="submit" class="btn btn-primary">
                                      Yes
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <!-- ✅ View More only when there is data -->
                  <div class="view-more-button">
                    <a [routerLink]="['/loan-report']">
                      View More
                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6H13M13 6L8.5 1.5M13 6L8.5 10.5" stroke="#2D2D2E" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </div>
                  } @else {
                  <div class="no-data">
                    <ng-lottie width="100%" height="auto" [options]="options"></ng-lottie>
                  </div>
                  }

                </div>



              </div>
            </div>
          </div>
        </div>
        <div class="devided-section">
          <div class="contact-info">
            <div class="card-heading">
              <h1>Contact Information</h1>
            </div>
            <div class="contact-body">
              <div class="contact-common">
                <div class="contact-img">
                  <img src="../../../assets/theme1/phone.png" />
                </div>
                <div class="contact-detail">
                  <h1><span>Phone Number:</span> {{user.phone_number}}</h1>
                </div>
              </div>
              <div class="contact-common">
                <div class="contact-img">
                  <img src="../../../assets/theme1/mail.png" />
                </div>
                <div class="contact-detail">
                  <h1><span>Email:</span> {{user.email}}</h1>
                </div>
              </div>
              <div class="contact-common">
                <div class="contact-img">
                  <img src="../../../assets/theme1/location.png" />
                </div>
                <div class="contact-detail">
                  <h1><span>Address:</span> {{user.address.address1}} </h1>
                </div>
              </div>
            </div>
          </div>
          <div class="birthday-section">
            <h1>Birthday</h1>
            <p>Make Your calendar! Your special day is coming on</p>
            <h1>{{birthday}}
              <img src="../../../assets/theme1/celebration.png" />
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-section">
      <div class="inner-footer-sec">
        <div class="contact-info">
          <div class="card-heading">
            <h1>Contact Information</h1>
          </div>
          <div class="contact-body">
            <div class="contact-common">
              <div class="contact-img">
                <img src="../../../assets/theme1/phone.png" />
              </div>
              <div class="contact-detail">
                <h1><span>Phone Number:</span> {{user.phone_number}}</h1>
              </div>
            </div>
            <div class="contact-common">
              <div class="contact-img">
                <img src="../../../assets/theme1/mail.png" />
              </div>
              <div class="contact-detail">
                <h1><span>Email:</span> {{user.email}}</h1>
              </div>
            </div>
            <div class="contact-common">
              <div class="contact-img">
                <img src="../../../assets/theme1/location.png" />
              </div>
              <div class="contact-detail">
                <h1><span>Address:</span> {{user.address.address1}} </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="birthday-section">
          <h1>Birthday</h1>
          <p>Make Your calendar! Your special day is coming on</p>
          <h1>{{birthday}}
            <img src="../../../assets/theme1/celebration.png" />
          </h1>
        </div>
      </div>
      <div class="gallery-section">
        <div class="card-heading">
          <h1>Announcements</h1>
          <div class="gallery-rout" [routerLink]="['/announcements']">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 6H13M13 6L8.5 1.5M13 6L8.5 10.5" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div class="announcement-images-section">
          <div class="annoucement-card-main">
            @if (showDescription && latestAnnoument.status === 'active') {
            <div class="annoucement-card-head">
              <div class="annoucement-profile-image">
                <img
                  [src]="latestAnnoument?.user?.profile_image ? latestAnnoument?.user?.profile_image : '../../assets/images/question.jpg'"
                  alt="admin image" />
              </div>
              <div class="annoucement-profile-detail">
                <h1>{{latestAnnoument.user.first_name}} {{latestAnnoument.user.last_name}}</h1>
                <p>{{latestAnnoument.user.description}}</p>
              </div>
            </div>
            }
            <div class="annoucement-body">
              @if (announcementfiles && announcementfiles.length > 0) {
              @if (showDescription || firstFile) {
              <div class="annoucement-card-image">
                <a [routerLink]="['/announcements']">
                  <!-- ✅ Show real file only if status is 'active' -->
                  @if (latestAnnoument.status === 'active') {
                  @if (announcementfiles[0] && isImage(announcementfiles[0])) {
                  <img [src]="announcementfiles[0]" alt="Announcement Image" />
                  } @if (announcementfiles[0] && isVideo(announcementfiles[0])) {
                  <video controls>
                    <source [src]="announcementfiles[0]" type="video/mp4" />
                  </video>
                  }
                  } @else {
                  @if (media[5]) {
                  <img [src]="getImagePath() + '/' + media[5].path" alt="slide">
                  }
                  @if (!media[5]) {
                  <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                  }
                  }
                  <!-- ✅ Placeholder shown if not active -->
                </a>
                @if (latestAnnoument.status === 'active') {
                <div class="annoucement-tag">
                  <p>New</p>
                </div>
                }
              </div>
              }
              }



              @if (showDescription && latestAnnoument?.status === 'active') {
              <a [routerLink]="['/announcements']" [ngClass]="{ 'with-file': firstFile, 'no-file': !firstFile }">
                <div class="annoucement-description">
                  <h1>{{latestAnnoument?.title}}</h1>
                  <p class="detail-text" [innerHTML]="latestAnnoument?.description"></p>
                  <div class="card-reaction-footer">
                    @for (reaction of getReactions(latestAnnoument?.reactionCounts); track reaction) {
                    <div class="reaction">
                      <img class="emoji" [src]="getReactionImage(reaction.type)" [alt]="reaction?.type" />
                      <span class="count">{{ reaction?.count }}</span>
                    </div>
                    }
                  </div>
                </div>
              </a>
              }


              @if (!showDescription || latestAnnoument.status !== 'active') {
              <div class="annoucement-card-image annoucement-second-image">
                @if (media[4]) {
                <img [src]="getImagePath() + '/' + media[4]?.path" alt="slide">
                }
                @if (!media[4]) {
                <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                }
              </div>
              }
              @if (!showDescription || latestAnnoument.status !== 'active') {
              <div class="annoucement-small-images">
                <div class="small-image">
                  @if (media[0]) {
                  <img [src]="getImagePath() + '/' + media[0]?.path" alt="slide">
                  }
                  @if (!media[0]) {
                  <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                  }
                </div>
                <div class="small-image">
                  @if (media[1]) {
                  <img [src]="getImagePath() + '/' + media[1]?.path" alt="slide">
                  }
                  @if (!media[1]) {
                  <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                  }
                </div>
                <div class="small-image">
                  @if (media[2]) {
                  <img [src]="getImagePath() + '/' + media[2]?.path" alt="slide">
                  }
                  @if (!media[2]) {
                  <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                  }
                </div>
                <div class="small-image">
                  @if (media[3]) {
                  <img [src]="getImagePath() + '/' + media[3]?.path" alt="slide">
                  }
                  @if (!media[3]) {
                  <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                  }
                </div>
              </div>
              }

            </div>

          </div>



        </div>



        <!-- gallery section -->
        <!-- <div class="gallery-images-section">
                              <div class="gallery-first-sec common-gallery">
                                <img *ngIf="media[0]" [src]="getImagePath() + '/' + media[0].path" alt="slide">
                              </div>
                              <div class="gallery-second-sec common-gallery">
                                <img *ngIf="media[1]" [src]="getImagePath() + '/' + media[1].path" alt="slide">
                              </div>
                              <div class="galery-third-sec common-gallery">
                                <img *ngIf="media[2]" [src]="getImagePath() + '/' + media[2].path" alt="slide">
                                <img *ngIf="media[3]" [src]="getImagePath() + '/' + media[3].path" alt="slide">
                              </div>
                            </div> -->
      </div>
    </div>
  </div>
</div>